export const AI_BUILDER_IN_SRV = 'RL:AIGenerationFlow';
export const MODULE_TYPE = {
  CRM_OBJECT: 'crmObject',
  DIMENSION: 'dimension',
  DATE_RANGE: 'dateRange',
  METRIC: 'metrics',
  FILTERS: 'filters'
};
export const UNINITIALIZED = 'UNINITIALIZED';
export const PENDING = 'PENDING';
export const SUCCEEDED = 'SUCCEEDED';
export const FAILED = 'FAILED';
export const FEEDBACK_COMPONENTS = Object.assign({}, MODULE_TYPE, {
  FREQUENCY: 'frequency'
});
export let AIReportUpdatablePropertyLayout;
(function (AIReportUpdatablePropertyLayout) {
  AIReportUpdatablePropertyLayout["Horizontal"] = "horizontal";
  AIReportUpdatablePropertyLayout["Vertical"] = "vertical";
})(AIReportUpdatablePropertyLayout || (AIReportUpdatablePropertyLayout = {}));